import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ServiceFrom from './ServiceForm';
import ServiceFormSerializer from '../../services/ServiceFormSerializer';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import * as contactPersonModalActions from '../../actions/contactPersonModalActions';
import * as categoriesActions from '../../actions/services/serviceCategoriesActions';
import * as serviceActions from '../../actions/services/servicesActions';
import ContactPersonModal from '../contact-person/ContactPersonModal';
import * as typesActions from '../../actions/productTypesActions';
import * as pendingPageActions from '../../actions/pendingPageActions';
import * as modalActions from '../../actions/common/modalActions';
import {toastr} from 'react-redux-toastr';
import { FormattedMessage, injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import Placeholder from "../Placeholder";
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";

class ServiceFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.onModalClick = this.onModalClick.bind(this);
        this.submit = this.submit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [
            this.props.actions.loadContactPersons(this.props.user.company.id),
            this.props.actions.loadCategories(this.props.user.company.portalId),
        ];

        if(this.isUpdate()) {
            actions.push(this.props.actions.getService(this.props.match.params.id));
        } else {
            actions.push(this.props.actions.resetService());
        }

        return actions;
    }

    submit(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let fields = ServiceFormSerializer.serialize(formFields, this.props.user.id);
        if(this.isUpdate()) {
            this.props.actions.updateService(fields, formFields.id).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.serviceUpdated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        } else {
            this.props.actions.saveService(fields).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                // toastr.success('Ydelse oprettet');
                toastr.success(this.props.intl.formatMessage(messages.serviceCreated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        }
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    confirmReset() {
        // this.props.actions.resetTip();
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    redirect() {
        this.context.router.history.push('/ydelse');
    }

    onModalClick() {
        this.props.actions.showContactPersonModal();
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{this.props.intl.formatMessage(messages.service)}</h1>
                                <ServiceFrom
                                    initialValues={this.props.service}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    contactPersons={this.props.contactPersons}
                                    categories={this.props.categories}
                                    handleModalClick={this.onModalClick}
                                    onSubmit={this.submit}
                                    handleReset={this.handleReset}
                                    isUpdate={this.isUpdate()}
                                />
                                <ContactPersonModal/>
                            </div>
                        </div>
                    </div>
                </div>
                <ResetFormModal
                    modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                    modalContent={
                        <p>
                            <FormattedMessage
                                id="reset.modal.message"
                                defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                            />
                        </p>}
                    confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                    closeText={this.props.intl.formatMessage(messages.buttonNo)}
                    handleConfirm={() => {this.confirmReset()}}
                />
            </div>
            </WithResolvedPromises>
        );
    }
}

ServiceFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let service = ServiceFormSerializer.unserialize(state.service);

    return {
        service: service,
        contactPersons: state.contactPersons,
        categories: state.serviceCategories,
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...serviceActions,
            ...contactPersonListActions,
            ...contactPersonModalActions,
            ...categoriesActions,
            ...typesActions,
            ...pendingPageActions,
            ...submitButtonActions,
            ...modalActions
        }, dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ServiceFormContainer));





// WEBPACK FOOTER //
// ./web/src/components/services/ServiceFormContainer.jsx